import { render, staticRenderFns } from "./produce_tab.vue?vue&type=template&id=69bcf2f0&scoped=true&"
import script from "./produce_tab.vue?vue&type=script&lang=js&"
export * from "./produce_tab.vue?vue&type=script&lang=js&"
import style0 from "./produce_tab.vue?vue&type=style&index=0&id=69bcf2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bcf2f0",
  null
  
)

export default component.exports